/** @module ProductSpec/SizeChart/CopyToMultipleController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/_base/underscore",
	"csi/xml",
	"csi/xml/Query"
], function(declare,Controller,_,xml,Query) {
	
	var DIMENSION_DEPENDENCIES = "DimensionDependencies";
	var DIMENSION_TYPE_BLANK = "DimensionType:";
	
	return declare(Controller, {
		/**
		 * @override
		 * Filter the list of SizeChart and Increment Dimensions on the "Copy to Multiple" action pop up dialog
		 */
		applyActionFilters: function(view) {
			var query = this._getQuery();
			if (query) {
				view.relRoot.addQuery(query);
			}
			this.inherited(arguments);
		},
			  
		/**
		 * @override
		 * Hide the dividers on the popup dialog
		 */
		onCreatePopupParams: function(params) {
			params.hideDividers = true;
		},
			
		/**
		 * Return Query
		 * @return {Query} 
		 */
		_getQuery: function() {
			var path = xml.path(this.dimensionId);
			var urlDim = this.getNode()[this.dimensionId];
			var thisDimension = this.getNode();
			var cache = this.getCache();
					
			var q = new Query();
			// The Dimension from which copy is occurring should not be displayed
			q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, this.getNodeURL());

			//Dimensions with read-only increments attribute should not be displayed
			q.Attr2("Increments", xml.OP_BIT_0, {
				Flag: xml.ATTR_FLAG_NOEDIT
			});

			var parentRev = cache.getNode(thisDimension.__Parent__);
			var dim2Type = parentRev.Dimension2Type;
			var isTwoDim = dim2Type && dim2Type != DIMENSION_TYPE_BLANK;

			// Case : Under a 2-Dim size chart
			if (isTwoDim) {
				var apparelDimension = cache.getNode(urlDim);
				var dimDependencies = apparelDimension ? apparelDimension.DimensionDependencies : [];

				var isDimensionTwoDim = _.contains(dimDependencies, dim2Type);
				if (isDimensionTwoDim) {
					//Case : 2-Dim dimension under dependencies path, only 2-Dim dimensions will be returned
					//2-dim Dimensions are Not empty and has DimensionDependencies contains the Dimension2Type
					q.Attr(DIMENSION_DEPENDENCIES, xml.OP_EQUALS, dim2Type, path);
				} else {
					//Case : 1-Dim dimension under dependencies path, only 1-Dim dimensions will be returned
					//1-dim Dimensions are either empty or DimensionDependencies NOT contains the Dimension2Type
					q.Not().Attr(DIMENSION_DEPENDENCIES, xml.OP_EQUALS, dim2Type, path);
				}
			}
			return q;
		}
	});
});